function isElementOk(element, validator) {
	if (element.dataset.validatedValue === element.value) {
		return element.dataset.validationResult === 'true';
	}

    let amountValidation = validator(element.value);
	element.dataset.validationResult = amountValidation.inRange;
	element.dataset.isGreaterThanMax = amountValidation.isGreater;
	element.dataset.validatedValue = element.value;

	return element.dataset.validationResult === 'true';
}

// Does not handle groups of inputs, e.g. checkboxes / radio
function validateFormElements(formElement, validators) {
	const validationResult = {
		success: undefined,
		errors: 0,
		fail: {},
		pass: {}
	};

	Object.keys(validators).forEach((elementName) => {
		const element = formElement[elementName];
		if (element) {
			const validator = validators[element.name];
			if (validator) {
				const scopedValidator = validator.bind(validators);
				const elementOk = isElementOk(element, scopedValidator);
				if (elementOk) {
					validationResult.pass[element.name] = element;
				} else {
					validationResult.fail[element.name] = element;
					validationResult.errors += 1;
				}
			}
		}
	});
	validationResult.ok = validationResult.errors === 0;

	return validationResult;
}

function getDelayedHandler(timeoutMs = 500) {
	const delayedHandlerData = {
		TIMEOUT_DELAY_MS: timeoutMs,
		timeoutId: undefined
	};

	const delayedHandler = (formHandler) => {
		if (delayedHandlerData.timeoutId) {
			window.clearTimeout(delayedHandlerData.timeoutId);
		}
		delayedHandlerData.timeoutId = window.setTimeout(formHandler, delayedHandlerData.TIMEOUT_DELAY_MS);
	};
	return delayedHandler;
}

function getDelayedFormInputHandler(formHandler, timeoutMs = 500) {
	const delayedHandlingOf = getDelayedHandler(timeoutMs);

	const delayedFormInputHandler = (_formHandler, event) => {
		if (event.currentTarget.tagName === 'FORM') {
			event.stopPropagation();

			event.target.dataset.edited = true;
			delayedHandlingOf(_formHandler);
		}
	};
	return delayedFormInputHandler.bind(null, formHandler);
}

export {
	getDelayedFormInputHandler,
	validateFormElements,
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/withdraw/validation.js